import { render, staticRenderFns } from "./label-item.vue?vue&type=template&id=479b2d5e&scoped=true&"
import script from "./label-item.vue?vue&type=script&lang=js&"
export * from "./label-item.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./label-item.vue?vue&type=style&index=1&lang=stylus&rel=stylesheet%2Fstylus&"
import style2 from "./label-item.vue?vue&type=style&index=2&id=479b2d5e&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b2d5e",
  null
  
)

export default component.exports